import { Navigate, Route, useNavigate, useLocation } from "react-router-dom";
import Video from "../pages/video";
import Play from "../pages/play";
import Login from "../pages/login";
import GameDesc from "../pages/gameDesc";
import Order from "../pages/order";
import AnimatedRouter from "react-animated-router"; //导入我们的的AnimatedRouter组件
import "react-animated-router/animate.css";
import { observer, inject } from "mobx-react";
import { useEffect, useState } from "react";

const myRoutes = [
  {
    path: "/",
    element: <Play />,
  },
  {
    path: "/video",
    element: <Video />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/gameDesc",
    element: <GameDesc />,
  },
  {
    path: "/order",
    element: <Order />,
  },
  {
    path: "/*",
    element: <Navigate to="/" />,
  },
];

// router.js
let needAnimation = true; // 控制滑动自带动画冲突

const delayReset = () => {
  // 延后重置控制参数
  setTimeout(() => {
    needAnimation = true;
  }, 20);
};

window.addEventListener("touchend", delayReset);

function AnimateRouter({ store }) {
  const navigate = useNavigate();
  const [needAnimation, setNeedAnimation] = useState();
  const location = useLocation();
  const isVideoPage = location.pathname === "/video";
  useEffect(() => {
    if (!isVideoPage) {
      store.getDicInfo();
    }
  }, []);
  useEffect(() => {
    if (navigate) {
      window.navigate = navigate;
    }
  }, [navigate]);

  useEffect(() => {
    window.addEventListener("touchstart", (e) => {
      setNeedAnimation(true);
    });
    window.addEventListener("touchmove", (e) => {
      setNeedAnimation(false);
    });
    window.addEventListener("touchend", () => {
      setTimeout(() => {
        setNeedAnimation(true);
      }, 20);
    });
  }, []);

  return (
    <AnimatedRouter
      component={null}
      enter={store.animate && needAnimation}
      exit={store.animate && needAnimation}
      key={store.uniKey}
    >
      {myRoutes.map((item) => (
        <Route path={item.path} element={item.element} key={item.path} />
      ))}
    </AnimatedRouter>
  );
}

export default inject("store")(observer(AnimateRouter));
